import { render, staticRenderFns } from "./productCollections.vue?vue&type=template&id=2334d6cc&scoped=true&"
import script from "./productCollections.vue?vue&type=script&lang=js&"
export * from "./productCollections.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2334d6cc",
  null
  
)

export default component.exports